import { call, put, takeLatest } from 'redux-saga/effects';
import { Map } from 'immutable';
import { Notification } from '@utils';
import {
  getHorarioFuncionamento as getHorarioFuncionamentoSdk,
  putHorarioFuncionamento as putHorarioFuncionamentoSdk,
} from '@sdk/Conectores/HorarioFuncionamento';

//Action Types
export const Types = {
  GET_HORARIO_FUNCIONAMENTO: 'GET_HORARIO_FUNCIONAMENTO',
  GET_HORARIO_FUNCIONAMENTO_SUCCESS: 'GET_HORARIO_FUNCIONAMENTO_SUCCESS',
  GET_HORARIO_FUNCIONAMENTO_ERROR: 'GET_HORARIO_FUNCIONAMENTO_ERROR',

  PUT_HORARIO_FUNCIONAMENTO: 'PUT_HORARIO_FUNCIONAMENTO',
  PUT_HORARIO_FUNCIONAMENTO_SUCCESS: 'PUT_HORARIO_FUNCIONAMENTO_SUCCESS',
  PUT_HORARIO_FUNCIONAMENTO_ERROR: 'PUT_HORARIO_FUNCIONAMENTO_ERROR',

  RESET_HORARIO_FUNCIONAMENTO: 'RESET_HORARIO_FUNCIONAMENTO',
};

//Action Creators
export const getHorarioFuncionamento = (idConfiguracao) => ({ type: Types.GET_HORARIO_FUNCIONAMENTO, idConfiguracao });
export const getHorarioFuncionamentoSuccess = (data) => ({ type: Types.GET_HORARIO_FUNCIONAMENTO_SUCCESS, data });
export const getHorarioFuncionamentoError = (error) => ({ type: Types.GET_HORARIO_FUNCIONAMENTO_ERROR, error });

export const putHorarioFuncionamento = (data) => ({ type: Types.PUT_HORARIO_FUNCIONAMENTO, data });
export const putHorarioFuncionamentoSuccess = () => ({ type: Types.PUT_HORARIO_FUNCIONAMENTO_SUCCESS });
export const putHorarioFuncionamentoError = (error) => ({ type: Types.PUT_HORARIO_FUNCIONAMENTO_ERROR, error });

export const reset = () => ({ type: Types.RESET_HORARIO_FUNCIONAMENTO });

function* fetchGetHorarioFuncionamento(action) {
  try {
    const horarioFuncionamento = yield call(getHorarioFuncionamentoSdk, action.idConfiguracao);
    yield put(getHorarioFuncionamentoSuccess(horarioFuncionamento));
  } catch (err) {
    Notification.error(err.message);
    yield put(getHorarioFuncionamentoError(err));
  }
}

function* fetchPutHorarioFuncionamento(action) {
  try {
    const { data } = action;
    yield call(putHorarioFuncionamentoSdk, data);
    yield put(putHorarioFuncionamentoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putHorarioFuncionamentoError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_HORARIO_FUNCIONAMENTO, fetchGetHorarioFuncionamento),
  takeLatest(Types.PUT_HORARIO_FUNCIONAMENTO, fetchPutHorarioFuncionamento),
];

// Reducer
const initialState = Map({
  horarioFuncionamento: {},

  loadingHorarioFuncionamento: false,
  successHorarioFuncionamento: false,
  errorHorarioFuncionamento: false,

  putingHorarioFuncionamento: false,
  successPutHorarioFuncionamento: false,
  errorPutHorarioFuncionamento: false,
});

const handleGetHorarioFuncionamento = (state, action) => {
  return state.set('loadingHorarioFuncionamento', true).set('successHorarioFuncionamento', false).set('errorHorarioFuncionamento', false);
};

const handleGetHorarioFuncionamentoSuccess = (state, action) => {
  return state
    .set('horarioFuncionamento', action.data)
    .set('loadingHorarioFuncionamento', false)
    .set('successHorarioFuncionamento', true)
    .set('errorHorarioFuncionamento', false);
};

const handleGetHorarioFuncionamentoError = (state, action) => {
  return state
    .set('loadingHorarioFuncionamento', false)
    .set('successHorarioFuncionamento', false)
    .set('errorHorarioFuncionamento', action.error);
};

const handlePutHorarioFuncionamento = (state, action) => {
  return state
    .set('putingHorarioFuncionamento', true)
    .set('successPutHorarioFuncionamento', false)
    .set('errorPutHorarioFuncionamento', false);
};

const handlePutHorarioFuncionamentoSuccess = (state, action) => {
  return state
    .set('putingHorarioFuncionamento', false)
    .set('successPutHorarioFuncionamento', true)
    .set('errorPutHorarioFuncionamento', false);
};

const handlePutHorarioFuncionamentoError = (state, action) => {
  return state
    .set('putingHorarioFuncionamento', false)
    .set('successPutHorarioFuncionamento', false)
    .set('errorPutHorarioFuncionamento', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_HORARIO_FUNCIONAMENTO:
      return handleGetHorarioFuncionamento(state, action);
    case Types.GET_HORARIO_FUNCIONAMENTO_SUCCESS:
      return handleGetHorarioFuncionamentoSuccess(state, action);
    case Types.GET_HORARIO_FUNCIONAMENTO_ERROR:
      return handleGetHorarioFuncionamentoError(state, action);

    case Types.PUT_HORARIO_FUNCIONAMENTO:
      return handlePutHorarioFuncionamento(state, action);
    case Types.PUT_HORARIO_FUNCIONAMENTO_SUCCESS:
      return handlePutHorarioFuncionamentoSuccess(state, action);
    case Types.PUT_HORARIO_FUNCIONAMENTO_ERROR:
      return handlePutHorarioFuncionamentoError(state, action);

    case Types.RESET_HORARIO_FUNCIONAMENTO:
      return handleReset(state, action);

    default:
      return state;
  }
}
